export function initUppercase($form) {
  const ns = '.admissaoUppercase'

  function applyToEl(el) {
    const pos = el.selectionStart
    el.value = el.value.toUpperCase()
    try { el.setSelectionRange(pos, pos) } catch (_) {}
  }

  $form.off(ns)
  $form.on(`input${ns}`, '.js-uppercase', function () { applyToEl(this) })

  // Aplica em valores já preenchidos (edição)
  $form.find('.js-uppercase').each(function () {
    if (this.value) this.value = this.value.toUpperCase()
  })

  return {
    destroy() { $form.off(ns) }
  }
}
